import { Euler, Vector2, Vector3 } from "three";
// Flux-typed constants
export const ZeroIVector2 = { x: 0, y: 0 };
export const ZeroIVector3 = { x: 0, y: 0, z: 0 };
// ThreeJS-typed constants
// NOTE: it's probably a very bad idea to have these as constants, because they are mutable objects
export const ZeroEuler = new Euler(0, 0, 0);
export const ZeroVector2 = new Vector2(0, 0);
export const ZeroVector3 = new Vector3(0, 0, 0);
// I noticed quickDecomp(..) logging warnings: "Max level (100) reached" in /dacre/island-remove-test-biskuit-comment-ref
// It seems quickDecomp(..) early exits if max level is reached, limiting the decomposition's accuracy - this value is
// selected as it ensures full decomposition for 👆 project
export const DecompMaxLevel = 115;
//# sourceMappingURL=constants.js.map